import { useEffect, useState } from "react";
import { api } from "@/lib/api";

interface AnnouncementItem {
  id: number;
  message: string;
  display_type?: "banner" | "popup";
}

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState<AnnouncementItem[]>([]);

  useEffect(() => {
    api
      .get<AnnouncementItem[]>("/announcements/active")
      .then((items) => setAnnouncements(items.filter((a) => (a.display_type ?? "banner") === "banner")))
      .catch(() => {});
  }, []);

  if (announcements.length === 0) return null;

  const text = announcements.map((a) => a.message).join("   ✦   ");

  return (
    <div className="w-full bg-primary text-primary-foreground text-sm font-medium py-2 overflow-hidden">
      <div className="flex whitespace-nowrap animate-[marquee_20s_linear_infinite]">
        <span className="px-8">{text}</span>
        <span className="px-8" aria-hidden>{text}</span>
      </div>
    </div>
  );
}
